"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOffersFilters = getOffersFilters;
const config_1 = __importDefault(require("@src/config"));
const offers_filters_1 = require("@src/types/offers-filters");
const axios_1 = require("./clients/axios");
async function getOffersFilters(selectedFilterItems) {
    const response = await axios_1.client.get(`${config_1.default.api}/0/offers-filters`, {
        params: {
            typ: selectedFilterItems[offers_filters_1.OfferFilterType.type],
            loc: selectedFilterItems[offers_filters_1.OfferFilterType.location],
            job: selectedFilterItems[offers_filters_1.OfferFilterType.jobArea],
            salaryMin: selectedFilterItems[offers_filters_1.OfferFilterType.salaryMin],
            salaryMax: selectedFilterItems[offers_filters_1.OfferFilterType.salaryMax],
            salaryRate: selectedFilterItems[offers_filters_1.OfferFilterType.salaryRate],
            co: selectedFilterItems[offers_filters_1.OfferFilterType.searchCompaniesSelected],
            kw: selectedFilterItems[offers_filters_1.OfferFilterType.searchKeywordsSelected],
            page: selectedFilterItems.page,
        },
    });
    return response.data;
}
